import { KpiSourceHierarchyPreferences } from '../../data-models/kpi-source-hierarchy.data-model';
import { IPreferencesV3DataModel } from '../../data-models/preferences-v3.data-model';
import { MaggieHttp } from '../MaggieHttp';

/**
 * Persists the org's KPI source hierarchy and kicks off an org-wide
 * re-resolution of KPI values. The recompute runs asynchronously on the API;
 * the response is the saved preference row.
 */
export async function updateKpiSourceHierarchy(payload: KpiSourceHierarchyPreferences) {
  const { data } = await MaggieHttp.maggie.put<
    KpiSourceHierarchyPreferences,
    IPreferencesV3DataModel<KpiSourceHierarchyPreferences>
  >('/kpiCustomData/source-hierarchy', payload);

  return data;
}
